
document.addEventListener('click', event => {

    let el = event.target.closest('[data-href]');
    if (! el) return;

    event.preventDefault();
    let link = url(el.dataset.href);
    window.location.assign(link);

}, false);
